export const ToasterMessage = {
  SendOtp: "OTP Sent Successfully.",
  VerifyOtp: "OTP Verified Successfully.",
  Register: "Registered Successfully.",
  Login: "Logged in Successfully.",
  Logout: "Logging out...",
  resetPassword: "Password Reset Successfully.",
  AddSociety: "Society Added Successfully.",
  ApproveSociety: "Society Approved Successfully.",
  RejectSociety: "Society Rejected Successfully.",
  SocietiesFetched: "Societies Fetched Successfully.",
  SwitchSociety: "Society Switched Successfully.",
  AddLevel: "Level Added Successfully.",
  Copied: "Copied to clipboard.",
  AddAttribute: "Attribute Added Successfully.",
  AddGroup: "Group Added Successfully.",
  UpdateAttribute: "Attribute Updated Successfully.",
  AddLevelData: "Level Data Added Successfully.",
  AddRole: "Role Added Successfully.",
  ApproveUser: "User Approved Successfully.",
  RejectUser: "User Rejected Successfully.",
  EditModulePermissions: "Module Permissions Updated Successfully.",
  AddComplaint: "Complaint Added Successfully.",
  AddStatus: "Complaint Status Added Successfully",
  EditStatus: "Complaint Status Updated Successfully",
  DeleteStatus: "Complaint Status Deleted Successfully",
  AddRating: "Rating Added Successfully.",
  EditRating: "Rating Updated Successfully",
  DeleteRating: "Complaint Rating Deleted Successfully",
  addMasterLifeCycle: "Lifecycle Added Successfully.",
  editMasterLifeCycle: "Lifecycle Updated Successfully.",
  deleteMasterLifeCycle: "Lifecycle Deleted Successfully.",
  changePriority: "Priority Updated Successfully.",
  closeComplaint: "Complaint Closed Successfully.",
  cancelComplaint: "Complaint Cancelled Successfully.",
  extendDeadline: "Deadline Extended Successfully.",
  reopenComplaint: "Complaint Reopened Successfully.",
  notifyUser: "User Notified Successfully.",
  resolveComplaint: "Complaint Resolved Successfully.",
  editLevel: "Level Updated Successfully.",
  assignVendor: "Vendor Assigned Successfully.",
  deleteRole: "Deleted Role Successfully",
  lastProcess:
    "You cannot update this complaint as its final process has already been completed.",
  switchRole: "Role Switched Successfully.",
  switchRoleLoading: "Switching Role please wait...",
  escalationAdded: "Escalation Added Successfully",
  addPriorityContact: "Priority Contact Added Successfully",
  escalationUpdated: "Escalation Updated Successfully",
  EcalationActive: "Escalation Status Updated Successfully",
  PriorityContact: "Priority Contact Updated Successfully",
  AddressAdded: "Address Added Successfully",
  ProcessUpdate: " Process Updated Successfully",
  DeadlineApprove: "Deadline Approved Successfully",
  DeadlineReject: "Deadline Rejected Successfully",
  CSVDownloaded: "CSV downloaded successfully!",
  CSVDownloadError: "No CSV available for downloading!",
  NoPriorityContact: "No priority contacts found",
  VerifyEmail: "Email Verified Successfully.",
  VerifyPhone: "Phone Verified Successfully.",
  AdvanceVendorSettingAdded: "Advance Vendor Setting Added Successfully",
  AddNotice: "Notice published successfully!",
  VendorAssignmentAdded: "Vendor Assignment Added Successfully",
  ResidentRemoved: "Resident Removed Successfully",
  AddFaq: "Faq Added Successfully.",
  DeleteLevelData: "Level Data Deleted Successfully",
  AddEscalation: "Escalation Added Successfully",
  AddNoticeDraft: "Notice saved as draft successfully!",
  EditNotice: "Notice Updated Successfully",
  DeleteNotice: "Notice Deleted Successfully",
  AddContactCategory: "Contact Category Added Successfully",
  EditContactCategory: "Contact Category Updated Successfully",
  DeleteContactCategory: "Contact Category Deleted Successfully",
  AddContactSubcategory: "Contact Subcategory Added Successfully",
  EditContactSubcategory: "Contact Subcategory Updated Successfully",
  DeleteContactSubcategory: "Contact Subcategory Deleted Successfully",
  AddContact: "Contact Added Successfully",
  DeleteContact: "Contact Deleted Successfully",  
  EditContact: "Contact Updated Successfully",
  AddEscalation: "Escalation Added Successfully",
  UpdatedOtherSetting: "Other Setting Updated Successfully",
  SaveMisSettings: "MIS Settings Saved Successfully",
  GetMisSettings: "MIS Settings Fetched Successfully",
  FetchMisSettings: "Fetching Previous MIS Settings...",
  AddComplaintDeadlineRule: "Complaint Deadline Rule Added Successfully",
  DeleteAddress: "User Address Deleted Successfully",
  UpdateProfileName: "Profile Name Updated Successfully",
  AddConnectedLevelData: "Connected Level Data Added Successfully",
  UploadHolidayMapping: "Holiday Mapping Uploaded Successfully",
  AddIndividualHoliday: "Holiday Added Successfully",
  DeleteHoliday: "Holiday Deleted Successfully",
};
